exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin-left:1%;margin-right:1%;margin-top:1%;font-family:\"Open Sans\", sans-serif}label{display:inline-block;width:100px}input{width:400px;padding:5px;font-size:16px}button{font-size:16px;padding:5px}h1,h2{display:inline-block;vertical-align:middle;margin-top:0px;margin-bottom:10px}h2{color:#AAA;font-size:32px}h3{font-weight:normal;color:#AAA;font-size:24px}.black{color:black}#balance{color:black}.hint{color:#666}\n", ""]);

// exports
